import React from 'react';
type WatermarkedImageProps = {
  src: string;
  alt: string;
  className?: string;
  wrapperClassName?: string;
  size?: 'sm' | 'md';
  /**
   * 'corner' places a single wordmark in the bottom-right corner.
   * 'full' tiles a faint wordmark across the entire image background.
   */
  variant?: 'corner' | 'full';
};
const tileRows = [0, 1, 2, 3, 4, 5];
const tileCols = [0, 1, 2, 3];

/**
 * Renders a blog image with a subtle IntelliEats brand watermark
 * (black wordmark + green accent). The watermark stays light enough
 * not to obscure the artwork.
 */
export function WatermarkedImage({
  src,
  alt,
  className = '',
  wrapperClassName = '',
  size = 'md',
  variant = 'corner'
}: WatermarkedImageProps) {
  const isSmall = size === 'sm';
  return <div className={`relative inline-block w-full overflow-hidden ${wrapperClassName}`} data-id="element-2135" data-mp="3t12fzo9a3lme">
      <img src={src} alt={alt} className={className} data-id="element-2136" data-mp="1uhv6m9th9xt" />

      {variant === 'full' && <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex select-none flex-col justify-around overflow-hidden" data-id="element-2137" data-mp="6s9kd8j2uhyb">
          {tileRows.map(row => <div key={row} className="flex items-center justify-around" style={{
        transform: `translateX(${row % 2 === 0 ? '-4%' : '4%'})`
      }} data-id="element-2138" data-mp="19dbtoiat7zw0">
              {tileCols.map(col => <span key={col} className="-rotate-[24deg] whitespace-nowrap text-[10px] font-black tracking-[0.2em] sm:text-sm" data-id="element-2139" data-mp="1x3y4ghc77y9p">
                  <span className="text-slate-900/[0.13]" data-id="element-2140" data-mp="1s7h6kvf765jf">Intelli</span>
                  <span className="text-brand-600/[0.18]" data-id="element-2141" data-mp="1nclbfmenz223">Eats</span>
                </span>)}
            </div>)}
        </div>}

      <span aria-hidden="true" className={`pointer-events-none absolute select-none rounded-full bg-white/70 font-black tracking-tight backdrop-blur-sm ${isSmall ? 'bottom-1.5 right-1.5 px-2 py-0.5 text-[9px]' : 'bottom-3 right-3 px-3 py-1 text-xs sm:text-sm'}`} data-id="element-2142" data-mp="2fv8nydflh8rk">
        <span className="text-slate-900/70" data-id="element-2143" data-mp="e506xtepcui9">Intelli</span>
        <span className="text-brand-600/80" data-id="element-2144" data-mp="3vmkrz9ru86rl">Eats</span>
      </span>
    </div>;
}